{
	"title": "Запись лекций",
	"list": {
		"sectionTitle": "Запись лекций",
		"title": "Все записи",
		"empty": "Нет записей",
		"newRecording": "Новая запись",
		"errorTitle": "Не удалось загрузить записи",
		"errorDescription": "Проверьте соединение и попробуйте снова.",
		"retry": "Повторить",
		"count": "{count, plural, one {# запись} few {# записи} many {# записей} other {# записи}}",
		"subtitle": "Расшифровка, разбивка по говорящим и конспект из каждой лекции",
		"emptyTitle": "Пока нет ни одной записи",
		"emptyDescription": "Запиши лекцию — мы расшифруем, разобьём по говорящим и сделаем конспект.",
		"startRecording": "Начать запись",
		"pendingUpload": "Запись ждёт сети — продолжите загрузку, когда появится Wi-Fi",
		"continueUpload": "Продолжить",
		"liveNow": "Идёт запись прямо сейчас",
		"liveOpen": "Открыть",
		"swipeDelete": "Удалить",
		"swipeNote": "Конспект",
		"listen": "Слушать",
		"searchPlaceholder": "Поиск по названию",
		"searchEmptyTitle": "Ничего не найдено",
		"searchEmptyDescription": "По запросу «{query}» записей нет. Измените запрос или фильтр.",
		"filterAll": "Все",
		"chunksProgress": "{uploaded} из {total} фрагментов загружено"
	},
	"recorder": {
		"ready": "Готов к записи",
		"readyHint": "Нажмите кнопку, чтобы начать. Расшифровка пойдёт в реальном времени.",
		"recording": "Идёт запись",
		"paused": "Пауза",
		"duration": "{minutes}:{seconds}",
		"levelLabel": "Уровень микрофона",
		"actions": {
			"start": "Начать запись",
			"starting": "Запускаем…",
			"pause": "Пауза",
			"resume": "Продолжить",
			"stop": "Остановить",
			"stopping": "Останавливаем…",
			"processing": "Обрабатываем…",
			"discard": "Отменить"
		},
		"banner": {
			"recording": "Идёт запись",
			"paused": "Пауза",
			"speakers": "{count, plural, one {# спикер} few {# спикера} many {# спикеров} other {# спикера}}",
			"online": "онлайн",
			"offline": "офлайн",
			"return": "Вернуться"
		},
		"settings": {
			"title": "Параметры записи",
			"diarization": "Распознавать спикеров",
			"diarizationHint": "Реплики будут разбиты по говорящим"
		},
		"micSource": {
			"label": "Источник микрофона",
			"placeholder": "Выберите микрофон",
			"empty": "Микрофоны не найдены",
			"revealNames": "Показать названия устройств",
			"switchFailed": "Не удалось переключить микрофон"
		},
		"permissionNeeded": "Нужен доступ к микрофону",
		"permissionDenied": "Доступ к микрофону запрещён",
		"startFailed": "Не удалось начать запись",
		"continueFailed": "Не удалось продолжить запись",
		"finalizeFailed": "Не удалось завершить запись",
		"defaultTitle": "Запись от {date}",
		"lockScreenHint": "Запись продолжится на заблокированном экране",
		"lockScreenHintUnsupported": "Не блокируйте экран — запись прервётся",
		"close": "Закрыть",
		"minimize": "Свернуть",
		"stopAndClose": "Остановить и закрыть",
		"back": "Назад",
		"titleEdit": "Изменить название",
		"titlePlaceholder": "Название записи",
		"renameError": "Не удалось переименовать",
		"exitConfirm": {
			"title": "Прервать запись?",
			"description": "Можно сохранить и запустить обработку сейчас или удалить запись без обработки.",
			"action": "Остановить и выйти",
			"stopAndProcess": "Остановить и обработать",
			"discard": "Удалить запись",
			"cancel": "Продолжить запись"
		},
		"queue": {
			"pending": "{count, plural, one {# фрагмент} few {# фрагмента} many {# фрагментов} other {# фрагмента}} в очереди",
			"pendingTitle": "Фрагменты записи ждут отправки на сервер",
			"finalizePending": "Нет сети — {count, plural, one {# фрагмент} few {# фрагмента} many {# фрагментов} other {# фрагмента}} ещё не загружен. Запись завершится автоматически после отправки.",
			"forceFinalize": "Завершить без них",
			"forceFinalizing": "Завершаем…",
			"allUploaded": "Все фрагменты загружены — обрабатываем запись",
			"dropped": "{count, plural, one {Не удалось загрузить # фрагмент} few {Не удалось загрузить # фрагмента} many {Не удалось загрузить # фрагментов} other {Не удалось загрузить # фрагмента}} — запись обработана без них",
			"undeliverable": "Не удалось сохранить фрагмент записи локально. Завершите вручную («Завершить без них») или повторите запись."
		},
		"noChunksWarning": "Звук с микрофона есть, но фрагменты записи не создаются. Остановите запись и начните заново — иначе лекция не сохранится."
	},
	"notes": {
		"title": "Заметки во время лекции",
		"addAt": "Заметка к {at}",
		"placeholder": "Заметка к {at}",
		"save": "Сохранить",
		"empty": "Заметки помогут позже быстро найти момент в записи.",
		"unsaved": "не сохранено",
		"unsavedHint": "Заметка не сохранилась на сервер. Будет повторена позже.",
		"delete": "Удалить"
	},
	"detail": {
		"allRecordings": "Все записи",
		"loadError": "Не удалось загрузить запись",
		"notFoundTitle": "Запись не найдена",
		"notFoundDescription": "Её нет в списке — возможно, она не сохранилась или была удалена. Вернитесь к списку записей.",
		"retry": "Повторить",
		"stalled": {
			"title": "Запись прервана",
			"description": "Запись прервалась — вероятно, страница была перезагружена или вкладка закрыта. Распознанный текст сохранён. Можно продолжить ту же лекцию, завершить обработку или удалить запись.",
			"failedTitle": "Запись не обработана",
			"failedDescription": "Обработка не была завершена. Распознанный текст сохранён — можно повторить обработку или удалить запись.",
			"continue": "Продолжить запись",
			"continuing": "Подключаем микрофон…",
			"continueToast": "Продолжаем ту же лекцию",
			"continueError": "Не удалось продолжить запись",
			"reprocess": "Повторить обработку",
			"reprocessing": "Запускаем…",
			"reprocessToast": "Запускаем повторную обработку…",
			"reprocessError": "Не удалось перезапустить обработку",
			"finalize": "Завершить и обработать",
			"finalizing": "Обрабатываем…",
			"delete": "Удалить запись",
			"finalizeToast": "Запускаем обработку записи…",
			"finalizeError": "Не удалось запустить обработку",
			"deleteToast": "Запись удалена",
			"deleteError": "Не удалось удалить запись"
		},
		"speakersCount": "{count, plural, one {# спикер} few {# спикера} many {# спикеров} other {# спикера}}",
		"speakersTitle": "Спикеры:",
		"speakerLabel": "Спикер {letter}",
		"speakerNumbered": "Спикер {number}",
		"player": {
			"title": "Аудиозапись лекции",
			"play": "Воспроизвести",
			"pause": "Пауза",
			"rewind": "Назад на 15 секунд",
			"forward": "Вперёд на 15 секунд",
			"unavailable": "Аудио недоступно — обработка ещё не завершена."
		},
		"transcriptTitle": "Транскрипт",
		"transcriptCount": "{count, plural, one {# реплика} few {# реплики} many {# реплик} other {# реплики}}",
		"transcriptEmpty": "Транскрипт пока пуст. Будет готов после завершения обработки.",
		"jumpToSegment": "Перейти к {time}",
		"note": {
			"title": "Конспект лекции",
			"emptyHint": "Создайте структурированный конспект на основе этой лекции — с заголовками, формулами и ключевыми тезисами.",
			"create": "Создать конспект",
			"creating": "Создаём конспект…",
			"queuedToast": "Запустили генерацию. Откроем конспект, как будет готов.",
			"open": "Открыть",
			"openNote": "Открыть конспект",
			"version": "версия {version}",
			"regenerate": "Перегенерировать",
			"regenerateShort": "Заново",
			"ready": "Конспект готов",
			"failed": "Не удалось запустить генерацию"
		},
		"menu": {
			"open": "Открыть",
			"actions": "Действия с записью",
			"generateNote": "Создать конспект",
			"delete": "Удалить запись",
			"deleteConfirm": "Удалить эту запись? Можно восстановить из корзины в течение 30 дней.",
			"deleteTitle": "Удалить запись?",
			"deleteCancel": "Отмена",
			"deletedToast": "Запись удалена",
			"deleteFailed": "Не удалось удалить"
		}
	},
	"doc": {
		"tabLive": "Конспект",
		"tabDoc": "Документ",
		"tabTranscript": "Транскрипт",
		"docTitle": "Конспект",
		"building": "Конспект формируется в реальном времени по мере записи…",
		"empty": "Структурированный конспект для этой записи ещё не сформирован.",
		"jumpTo": "Перейти к {time}",
		"audioUnsupported": "Ваш браузер не поддерживает аудио."
	},
	"export": {
		"download": "Скачать",
		"menuTitle": "Скачать запись",
		"transcriptTxt": "Транскрипт (.txt)",
		"documentMd": "Конспект (.md)",
		"audioMp3": "Аудио (.mp3)",
		"audioPreparing": "Готовим аудио…",
		"audioPreparingToast": "MP3 готовится — сообщим, когда будет готов",
		"audioReady": "Аудио готово к скачиванию",
		"audioReadyAction": "Скачать",
		"audioFallback": "MP3 недоступен — скачивается исходный файл (WAV/WebM)",
		"failed": "Не удалось скачать файл",
		"fallbackName": "запись"
	},
	"transcription": {
		"title": "Транскрипция",
		"inProgress": "Расшифровываем…",
		"ready": "Транскрипция готова",
		"failed": "Не удалось расшифровать",
		"speaker": "Спикер {n}",
		"liveTitle": "Транскрипция в реальном времени",
		"liveBadge": "В эфире",
		"liveEmpty": "Транскрипция появится здесь, когда начнётся запись.",
		"liveStarting": "Первые реплики появятся через 10–20 секунд после начала речи."
	},
	"postProcess": {
		"title": "Обработка записи",
		"notesReady": "Конспект готов",
		"flashcardsReady": "Карточки готовы",
		"summaryReady": "Резюме готово"
	},
	"processing": {
		"title": "Обрабатываем запись...",
		"tip": "Можно закрыть страницу — вернёмся к тебе уведомлением, когда будет готово.",
		"stages": {
			"merging-chunks": "Склейка чанков",
			"diarizing": "Разделение по говорящим",
			"transcribing": "Расшифровка речи",
			"post-processing": "Очистка и форматирование"
		}
	},
	"manualNotes": {
		"title": "Заметки во время лекции",
		"addNote": "Добавить заметку",
		"placeholder": "Заметка к {timestamp}",
		"jumpTo": "К моменту {timestamp}"
	},
	"upload": {
		"selectAudio": "Загрузить аудио",
		"selectVideo": "Загрузить видео"
	},
	"intro": {
		"title": "Расшифровка идёт во время лекции",
		"body": "Текст появляется по ходу записи, а не после неё. Здесь звук превращается в текст; обратное направление — в аудио-резюме.",
		"bullets": [
			"Заметка во время записи привязывается к секунде",
			"Связь оборвалась — недозаписанное дозальётся позже",
			"Пишет только с микрофона: готовый файл — в Библиотеку"
		]
	}
}
